import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { FC } from "react";

import { Container } from "@/components/General/Grid/container.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { DeliveryPromiseComponentProps } from "../OrderItem/orderItem.component";
import { ProductCollectionBlockComponent } from "./productCollectionBlock.component";

type ProductCollectionProps = {
    collectProducts: Array<OrderItem>;
    deliveryProducts: Array<OrderItem>;
    additionalServiceTooltip?: TooltipType;
    productTitleLink: boolean;
    reviewsAllowed: boolean;
    DeliveryPromiseComponent: FC<DeliveryPromiseComponentProps>;
};

const ProductCollectionBlock = ({
    collectProducts,
    deliveryProducts,
    additionalServiceTooltip,
    productTitleLink,
    reviewsAllowed,
    DeliveryPromiseComponent
}: ProductCollectionProps) => {
    const { t } = useGranite();

    const isClickAndCollect = collectProducts.length > 0;
    const isHomeDelivery = deliveryProducts.length > 0;

    return (
        <>
            <h3>{t("orderOverview.label.products")}</h3>
            <Container>
                {isClickAndCollect && (
                    <ProductCollectionBlockComponent
                        icon={"la-hand-pointer"}
                        title={t("orderOverview.title.clickAndCollect")}
                        products={collectProducts}
                        deliveryType={DeliveryType.ClickAndCollect}
                        productTitleLink={productTitleLink}
                        reviewsAllowed={reviewsAllowed}
                        DeliveryPromiseComponent={DeliveryPromiseComponent}
                    />
                )}
                {isHomeDelivery && (
                    <ProductCollectionBlockComponent
                        icon={"la-truck"}
                        title={t("orderOverview.title.homeDelivery")}
                        products={deliveryProducts}
                        deliveryType={DeliveryType.HomeDelivery}
                        additionalServiceTooltip={additionalServiceTooltip}
                        productTitleLink={productTitleLink}
                        reviewsAllowed={reviewsAllowed}
                        DeliveryPromiseComponent={DeliveryPromiseComponent}
                    />
                )}
            </Container>
        </>
    );
};

export { ProductCollectionBlock };
